import React, {Component} from "react";
import {Autocomplete, Button, Chip, IconButton, Popover, Stack, Tab, Tabs, TextField, Tooltip} from "@mui/material";
import {connect} from "react-redux";
import {BorderVertical, Sync} from "@mui/icons-material";
import {morphleBaseTheme1} from "../themes";
import {mapSlides, reset, saveMapsPosition, toggleSync} from "../utils/splitSyncUtils";
import {isNull} from "../../../utils/utils";
import {updateDisplayedMap} from "../../../redux_actions/gamma.state.action";
import {addSlideToSplitSyncView, replaceSlidesInSplitSyncView} from "../../../redux_actions/splitSyncSlides.action";
import {performAbortControllerSlideSearch} from "../../../utils/api";

class SplitSync extends Component {

    constructor(props) {
        super(props);

        this.state = this.initState();

        if (this.props.sync) {
            saveMapsPosition(this.props.mapsState);
        }
    }

    initState = () => {
        let slides = [];
        if (this.props.displayedMapId) {
            for (const mapId in this.props.mapsState) {
                if (mapId === this.props.displayedMapId) {
                    this.props.dispatch(addSlideToSplitSyncView({
                        id: (this.props.mapsState[mapId].slide || {}).id,
                        name: (this.props.mapsState[mapId].slide || {}).name,
                    }))
                }
            }
        } else {
            for (const mapId in this.props.mapsState) {
                slides.push({
                    id: (this.props.mapsState[mapId].slide || {}).id,
                    name: (this.props.mapsState[mapId].slide || {}).name,
                })
            }
            this.props.dispatch(replaceSlidesInSplitSyncView(slides))
        }

        return {
            anchorEl: null,
            value: false,
            selectedSlides: slides,
            options: [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.mapsState !== prevProps.mapsState) {
            this.setState(this.initState());
        }
    }

    mapSlides = () => {
        mapSlides(this.props.slideList.slides);
        this.props.dispatch(updateDisplayedMap(null))
    }

    handleTabChange = (event, value) => {
        event.stopPropagation();
        this.setState({
            anchorEl: event.currentTarget,
            value: value,
        });
    }

    handleTabClose = () => {
        this.setState({
            anchorEl: null,
            value: false
        });
    }

    isSelected = option => this.state.selectedSlides.some(slide => slide.id === option.id);

    updateSlideSearchResults = (data) => {
        if(data.length > 0){
            const filteredOptions = data
                .filter(option => !this.props.slideList.slides.some(slide => slide.id === option.id));
            const nameCount = {};
            const uniqueFilteredOptions = filteredOptions.map(slide => {
                const baseName = slide.display_text.toUpperCase();
                let newName = baseName;
                if (nameCount[baseName]) {
                    nameCount[baseName] += 1;
                    newName = `${baseName} (${nameCount[baseName]-1})`;
                } else {
                    nameCount[baseName] = 1; 
                }
                return {
                    ...slide,
                    name: newName
                };
            });
            this.setState({
                options: uniqueFilteredOptions
            });
        }else{
            this.setState({
                options: []
            })
        }
    }

    render() {
        let isDisabled = !isNull(this.props.displayedMapId)

        return (
            <>
                <Tabs value={this.state.value} onChange={this.handleTabChange} scrollButtons="auto">
                    <Tooltip title={"Split"} placement={"bottom"}>
                        <Tab icon={<BorderVertical/>}/>
                    </Tooltip>
                    <Tooltip title={isDisabled ? "Split slide to sync" : "Sync"} placement={"bottom"}>
                        <IconButton onClick={toggleSync} sx={{verticalAlign: 'middle'}}
                                    disabled={isDisabled}>
                            {this.props.sync ?
                                <Sync sx={{color: morphleBaseTheme1.palette.headBarIcon.secondary}}/> :
                                <Sync sx={{
                                    color: morphleBaseTheme1.palette.headBarIcon.primary,
                                    opacity: isDisabled ? 0.6 : 1
                                }}/>}
                        </IconButton>
                    </Tooltip>
                </Tabs>
                <Popover open={!!this.state.anchorEl} anchorEl={this.state.anchorEl}
                         anchorOrigin={{
                             vertical: 'bottom',
                             horizontal: 'left',
                         }}
                         onClose={this.handleTabClose}>
                    <Autocomplete multiple sx={{width: '12vw'}} disableClearable
                                  freeSolo forcePopupIcon={false} value={this.props.slideList.slides}
                                  onChange={(event, values) => {
                                      if(event.code === "Backspace") {
                                          return
                                      }
                                      values = values.filter(value => value.id && value.name)
                                      this.props.dispatch(replaceSlidesInSplitSyncView(values))
                                  }}
                                  onInputChange={(e, value) => {
                                      performAbortControllerSlideSearch(value, this.updateSlideSearchResults, true)
                                  }}
                                  renderInput={(params) =>
                                      <TextField {...params} variant="outlined" placeholder={"Type Slide Name..."}/>}
                                  renderTags={(slides, getSlideProps) =>
                                      slides.map((slide, index) =>
                                          <Chip label={slide.name} variant={"filled"}
                                                sx={{width: "90%", justifyContent: "right"}}
                                                {...getSlideProps({index})}
                                                disabled={slide.id === this.props.slide?.id}/>)}
                                  options={this.state.options}
                                  getOptionLabel={option => option.name}
                    />
                    <Stack direction={"row"} justifyContent={"space-around"}>
                        <Button disabled={isDisabled} color={"secondary"}
                                onClick={reset}>Reset</Button>
                        <Button disabled={this.props.slideList.slides.length <= 1} color={"secondary"}
                                onClick={this.mapSlides}>Split</Button>
                    </Stack>
                </Popover>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    let mapsState = state.mapsStateReducer;
    let {activeMapId, displayedMapId, sync} = state.gammaStateReducer;
    let {slide} = mapsState[activeMapId];
    let slideList = state.splitSyncSlideReducer;
    return {mapsState, sync, activeMapId, displayedMapId, slide, slideList};
}

export default connect(mapStateToProps)(SplitSync)
